// ✅ US Market Forgot Password - Thin Wrapper (DRY principle)
import ForgotPasswordPage from '../forgot-password';
import SEOHead from '../../components/SEOHead';

export default function USForgotPassword() {
  return (
    <>
      <SEOHead
        title='Forgot Password | LB Visible'
        description='Reset your password'
        canonicalUrl='/us/forgot-password'
        lang='en'
        noIndex
        hreflang={[
          { hreflang: 'en-GB', href: 'https://www.lbvisible.com/forgot-password' },
          { hreflang: 'en-US', href: 'https://www.lbvisible.com/us/forgot-password' },
          { hreflang: 'lt-LT', href: 'https://www.lbvisible.com/lt/pamirsau-slaptazodi' },
          { hreflang: 'x-default', href: 'https://www.lbvisible.com/forgot-password' },
        ]}
      />
      <ForgotPasswordPage />
    </>
  );
}
